export default __webpack_public_path__ + "static/media/Logo-SET-Learn-Scape.1d0aaa65.png";